import { useQuery } from "@tanstack/react-query";
import { VendorService } from "src/services";
import { queryKeys } from "src/constants";

const useVendorNames = (vendorService: VendorService) => {
  const {
    data: vendorNames,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.vendorNames(),
    queryFn: () => vendorService.getVendorNames()
  });

  return { vendorNames, fetchError, isLoading, refetch };
};

export { useVendorNames };
